import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import DetailContainer from "~/Containers/DetailContainer";
import FeaturedOtdPost from "~/Components/FeaturedOtdPost";
import RelatedPostsSection from "~/Components/RelatedPostsSection";
import WidePageSection from "~/Components/Global/WidePageSection";
import Spinner from "react-bootstrap/Spinner";

import styled from "styled-components";

export const PreviouslyPostedWrapper = styled.section`
  margin: 20px 0 10px 0;
  font-size: 14px;
  color: #333;
  text-align: right;
  font-weight: bold;
`;

const Kba = window.dreamchimney && window.dreamchimney.kba;

const DetailPage = ({ match }) => {
  const { slug } = match.params;

  return (
    <div className="home-page-component">
      <div>
        <DetailContainer
          slug={slug}
          render={({ item, date, loading, failure }) => (
            <Row>
              <Col xs={12}>
                {loading && (
                  <div className="container-loading">
                    <Spinner animation="border" size="sm" /> Loading...
                  </div>
                )}
                {!loading && !failure && (
                  <React.Fragment>
                    <Helmet>
                      <title>____ of the Day | {item.otd_title} of the Day | Dream Chimney</title>
                      <meta property="og:title" content={`"${item.otd_title}" of the Day | Dream Chimney`}></meta>
                      <meta property="og:description" content={`"${item.otd_title}" of the Day | Dream Chimney`}></meta>
                      {item && item.img_url && item.img_url !== "" && (
                        <meta property="og:image" content={`https://www.dreamchimney.com/${item.img_url}`}></meta>
                      )}
                      <meta property="og:url" content={`https://www.dreamchimney.com/oftheday/${slug}`}></meta>
                      <link rel="canonical" href={`https://www.dreamchimney.com/oftheday/${slug}`} />
                    </Helmet>
                    <WidePageSection className={date ? "pageWithSidebar-detail" : ""}>
                      {date && <PreviouslyPostedWrapper>Originally posted: {date}</PreviouslyPostedWrapper>}
                      <FeaturedOtdPost otd={item} />
                    </WidePageSection>
                    {Kba && (
                      <div style={{ paddingTop: "30px" }}>
                        <Kba />
                      </div>
                    )}
                    <RelatedPostsSection postId={item.id} />
                    {Kba && (
                      <div style={{ paddingTop: "30px", paddingBottom: "30px" }}>
                        <Kba />
                      </div>
                    )}
                  </React.Fragment>
                )}
                {failure && (
                  <div style={{ paddingBottom: 80 }}>
                    <div className="pageTitle">This specific post was not found.</div>
                    <p>
                      But there are so many other similar ones. Try our{" "}
                      <Link to={`/search`} style={{ color: "white" }}>
                        search option
                      </Link>{" "}
                      for more good stuff.
                    </p>
                  </div>
                )}
              </Col>
            </Row>
          )}
        />
      </div>
    </div>
  );
};

export default DetailPage;
